import { ReactNode } from "react";

/** One titled block of the Index tab. */
export const Section = ({
  title,
  question,
  action,
  children,
}: {
  title: string;
  /** What the table answers, when the title does not say. */
  question?: string;
  /** A control belonging to the heading, such as a prune button. */
  action?: ReactNode;
  children: ReactNode;
}) => (
  <section className="flex flex-col gap-3">
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-3">
        <h2 className="text-sm font-semibold">{title}</h2>
        {action}
      </div>
      {question && <p className="text-xs text-muted-foreground">{question}</p>}
    </div>
    {children}
  </section>
);
